import { type ReactElement } from 'react';
import { useStrapiApi, useStrapiParams } from '@/hooks';
import { getHomeStrapi } from '@/services/strapi/getHome';
import {
	AtencionAlCiudadano,
	BannerActualidad,
	BannerFundaciones,
	BlogCategories,
	Buscadores,
	FNSignum,
	Hero,
} from '@/components';

const TIME_SLIDES = 10000;

export const Home = (): ReactElement => {
	const params = useStrapiParams({
		populate: {
			hero: {
				populate: ['images'],
			},
			banner: true,
			bannerFundaciones: {
				populate: ['image'],
			},
		},
	});

	const { data } = useStrapiApi(getHomeStrapi, {
		autoFetch: true,
		params,
	});

	return (
		<>
			<Hero images={data?.hero.images ?? []} intervalMs={TIME_SLIDES} heightPx={320} mtOffsetPx={-42} />
			<BannerActualidad items={data?.banner ?? []} />
			<Buscadores />
			<BlogCategories />
			<AtencionAlCiudadano />
			<FNSignum />
			<BannerFundaciones items={data?.bannerFundaciones ?? []} intervalMs={TIME_SLIDES} />
		</>
	);
};
